import { render } from "./ActivityRowHeard.vue?vue&type=template&id=48f47a96"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__